import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { spawnEmojiInFrontOfUser, emojis } from "../../components/emoji";
import { defineMessages, useIntl } from "react-intl";
import { ToolbarEmojisButton } from "./FluentToolbarEmojisButton";
import { useToolbarContext } from "../contexts/ToolbarContext";

// const emojiLabels = defineMessages({
//   smile: { id: "reaction-popover.emoji-label.smile", defaultMessage: "Smile" },
//   laugh: { id: "reaction-popover.emoji-label.laugh", defaultMessage: "Laugh" },
//   clap: { id: "reaction-popover.emoji-label.clap", defaultMessage: "Clap" },
//   heart: { id: "reaction-popover.emoji-label.heart", defaultMessage: "Heart" },
//   wave: { id: "reaction-popover.emoji-label.wave", defaultMessage: "Wave" },
//   // angry: { id: "reaction-popover.emoji-label.angry", defaultMessage: "Angry" },
//   cry: { id: "reaction-popover.emoji-label.cry", defaultMessage: "Cry" },
//   tired: { id: "reaction-popover.emoji-label.tired", defaultMessage: "Tired" },
//   tongue: { id: "reaction-popover.emoji-label.tongue", defaultMessage: "Tongue" },
//   triumph: { id: "reaction-popover.emoji-label.triumph", defaultMessage: "Triumph" },
//   wink: { id: "reaction-popover.emoji-label.wink", defaultMessage: "Wink" },
//   worried: { id: "reaction-popover.emoji-label.worried", defaultMessage: "Worried" },
//   yum: { id: "reaction-popover.emoji-label.yum", defaultMessage: "Yum" }
// });

export default function ToolbarEmojisContainer({ styles }) {
  const { emojisOpen, onEmojisOpenChange } = useToolbarContext();

  const items = emojis.map(emoji => ({
    src: emoji.particleEmitterConfig.src,
    onSelect: spawnEmojiInFrontOfUser,
    // label: intl.formatMessage(emojiLabels[emoji.id]),
    ...emoji
  }));

  return <ToolbarEmojisButton items={items} styles={styles} open={emojisOpen} onOpenChange={onEmojisOpenChange} />;
}

ToolbarEmojisContainer.propTypes = {
  scene: PropTypes.object,
  initialPresence: PropTypes.object,
  styles: PropTypes.object,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func
};
